import React from 'react';

const Hero = () => {

  return (
    <div
      className="hero h-96 mt-16"
      style={{ backgroundImage: "url('/spencer-demera-livermore-unsplash2.jpg')" }}
    >
      <div className="hero-overlay bg-opacity-60"></div>
      <div className="hero-content text-center text-white pb-0">
        <div className="max-w-xl">
          <h1 className="font-heading text-5xl font-bold">Membership</h1>
          <p className="py-6 text-center">Livermore Lodge 219</p>
          <p className="py-6 text-center italic">Friendship, Love and Truth</p>
        </div>
      </div>
    </div>
  )
}

export default Hero;